import { useEffect, useRef } from 'react';
import { Chart as ChartJS } from 'chart.js';

export function useChartAriaLabel(
  ariaLabel: string,
  externalRef?: React.RefObject<ChartJS | null>
) {
  // Use the passed external ref, or fall back to a local one
  const localRef = useRef<ChartJS>(null);
  const chartRef = externalRef || localRef;

  useEffect(() => {
    if (!ariaLabel) return;

    const applyAriaLabel = () => {
      const canvas = chartRef.current?.canvas;
      if (!canvas) return;

      canvas.setAttribute('role', 'img');
      canvas.setAttribute('aria-label', ariaLabel);
    };

    applyAriaLabel();
    const frameId = window.requestAnimationFrame(applyAriaLabel);

    return () => window.cancelAnimationFrame(frameId);
  }, [ariaLabel, chartRef]); // Added chartRef to dependencies

  return chartRef;
}
